import { getPaxAccessToken } from 'helper/grab-id-auth-helper';
import { createActionType, createFetchAction } from './action-helper';
import endpoints from './history-endpoints';
import appEndpoints from './login-endpoints';
import generalEndpoints from './general-endpoints';

export const ADD_BREADCUMB_PIECE = 'ADD_BREADCUMB_PIECE';
export const INVALID_TOKEN = 'INVALID_TOKEN';
export const LOG_OUT_CLEAN_UP = 'LOG_OUT_CLEAN_UP';
export const logOutCleanUp = () => ({
  type: LOG_OUT_CLEAN_UP,
});

export const EMPTY_ACTION = 'EMPTY_ACTION';
export const emptyAction = () => ({
  type: EMPTY_ACTION,
});

export const SAVE_CITY = 'SAVE_CITY';
export const FETCH_HISTORY_NOTIFICATION = createActionType(
  'FETCH_HISTORY_NOTIFICATION',
);
export const FETCH_INITIAL_USER_CONFIGURATION = createActionType(
  'FETCH_INITIAL_USER_CONFIGURATION',
);
export const FETCH_USER_CONFIGURATION = createActionType(
  'FETCH_USER_CONFIGURATION',
);
export const FETCH_PAX_CONFIGURATION = createActionType(
  'FETCH_PAX_CONFIGURATION',
);
export const FETCH_CITY = createActionType('FETCH_CITY');

export const addBreadcumbPieceAction = data => ({
  type: ADD_BREADCUMB_PIECE,
  data,
});

export const fetchCityOptions = (params, callback) =>
  createFetchAction(
    FETCH_CITY,
    generalEndpoints.getCityOptions(params),
    {
      method: 'GET',
    },
    callback,
  );

export const saveCityAction = city => ({
  type: SAVE_CITY,
  city,
});

export const fetchHistoryNotificationAction = (companyID, callback) =>
  createFetchAction(
    FETCH_HISTORY_NOTIFICATION,
    endpoints.getHistoryNotificationEpt(companyID),
    {
      method: 'GET',
    },
    callback,
  );

// used for first time fetching gfb user config
export const fetchInitialUserConfigurationAction = (
  companyID,
  cityCode,
  cityID,
) =>
  createFetchAction(
    FETCH_INITIAL_USER_CONFIGURATION,
    appEndpoints.getUserConfiguration(companyID, cityCode, cityID),
    {
      method: 'GET',
    },
  );

// used for subsequent time fetching gfb user config
export const fetchUserConfigurationAction = (companyID, cityCode, cityID) =>
  createFetchAction(
    FETCH_USER_CONFIGURATION,
    appEndpoints.getUserConfiguration(companyID, cityCode, cityID),
    {
      method: 'GET',
    },
  );

export const fetchPaxConfigurationAction = (
  countryCode,
  cityCode,
  cityID,
  companyID,
) =>
  createFetchAction(
    FETCH_PAX_CONFIGURATION,
    appEndpoints.paxGetUserConfiguration(
      countryCode,
      cityCode,
      cityID,
      companyID,
    ),
    {
      method: 'GET',
    },
  );

// ----------------------V2------------------------

export const GLOBAL_INIT_CLIENT = 'GLOBAL_INIT_CLIENT';
export const GLOBAL_INIT_CLIENT_ERROR = 'GLOBAL_INIT_CLIENT_ERROR';
export const FINISH_INIT_SERVICE_TYPES = 'FINISH_INIT_SERVICE_TYPES';

export const globalInitFailureAction = () => ({
  type: GLOBAL_INIT_CLIENT_ERROR,
});

export const HYDRA_SCAN_START = 'HYDRA_SCAN_START';
export const hydraScanStartAction = (sourceType, data) => ({
  type: HYDRA_SCAN_START,
  sourceType,
  data, // should contain { thanosExternalIntimateLoginResponse }
});

export const HYDRA_SCAN_END = 'HYDRA_SCAN_END';
export const hydraScanEndAction = (sourceType, error) => ({
  type: HYDRA_SCAN_END,
  sourceType,
  error,
});

export const SET_COMPANY_AND_GROUP = 'SET_COMPANY_AND_GROUP';
export const setCompanyAndGroup = (company, group) => ({
  type: SET_COMPANY_AND_GROUP,
  payload: {
    company,
    group,
  },
});
export const resetCompanyAndGroup = () => ({
  type: SET_COMPANY_AND_GROUP,
  payload: {
    company: {},
    group: {},
  },
});

export const TOGGLE_LOCATION_DRAWER = 'TOGGLE_LOCATION_DRAWER';
export const toggleLocationDrawerAction = (
  locations,
  isSender = false,
  allowDrag = false,
) => ({
  type: TOGGLE_LOCATION_DRAWER,
  payload: { locations, isSender, allowDrag }, // locations is POI objects [{ id, latlng, address... }]
});

export const SELECT_CITY = 'SELECT_CITY';
export const selectCityAction = payload => ({
  type: SELECT_CITY,
  payload,
});

export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';
export const pushNotificationAction = payload => ({
  type: PUSH_NOTIFICATION,
  payload, // array or single object of { id, type, message, custom }
});

export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const clearNotificationAction = payload => ({
  type: CLEAR_NOTIFICATION,
  payload,
});

export const PUSH_ERROR_MODAL = 'PUSH_ERROR_MODAL';
export const pushErrorModalAction = payload => ({
  type: PUSH_ERROR_MODAL,
  payload,
});

export const CLEAR_ERROR_MODAL = 'CLEAR_ERROR_MODAL';
export const clearErrorModalAction = () => ({
  type: CLEAR_ERROR_MODAL,
});

export const TOGGLE_APPBAR = 'TOGGLE_APPBAR';
export const toggleAppbarAction = () => ({
  type: TOGGLE_APPBAR,
});

export const PAX_FETCH_BUSINESS_PROFILES = createActionType(
  'PAX_FETCH_BUSINESS_PROFILES',
);
export const paxFetchBusinessProfilesAction = countryCode =>
  createFetchAction(
    PAX_FETCH_BUSINESS_PROFILES,
    appEndpoints.paxFetchBusinessProfilesEpt(countryCode),
    {},
    null,
    { type: 'Authorization', value: `Bearer ${getPaxAccessToken()}` },
  );

export const FETCH_FAILED_PAYMENTS_LIST = createActionType(
  'FETCH_FAILED_PAYMENTS_LIST',
);
export const getFailedPaymentsListAction = () =>
  createFetchAction(
    FETCH_FAILED_PAYMENTS_LIST,
    generalEndpoints.failedPaymentsListEpt(),
    { method: 'GET' },
  );

export const SET_BLOCK_CASHLESS_PAYMENTS = 'SET_BLOCK_CASHLESS_PAYMENTS';
export const setBlockCashlessPaymentsAction = payload => ({
  type: SET_BLOCK_CASHLESS_PAYMENTS,
  payload,
});

export const SET_FAILED_PAYMENTS_RETRY_STATUS =
  'SET_FAILED_PAYMENTS_RETRY_STATUS';
export const setFailedPaymentsRetryStatusAction = payload => ({
  type: SET_FAILED_PAYMENTS_RETRY_STATUS,
  payload,
});

export const showFailedPaymentsRetryModalAction = () => ({
  type: SET_FAILED_PAYMENTS_RETRY_STATUS,
  payload: { listFailedPaymentsModalVisible: true },
});

export const RETRY_FAILED_PAYMENTS = createActionType('RETRY_FAILED_PAYMENTS');
export const retryFailedPaymentsAction = payload =>
  createFetchAction(
    RETRY_FAILED_PAYMENTS,
    generalEndpoints.retryfailedPaymentsEpt(),
    { method: 'POST', body: payload },
  );

export const LOCATION_DRAWER_ROUTE_OPTIMIZATION = createActionType(
  'LOCATION_DRAWER_ROUTE_OPTIMIZATION',
);

export const locationDrawerFindShortestRouteAction = () => ({
  type: LOCATION_DRAWER_ROUTE_OPTIMIZATION.START,
});

export const UPDATE_OPTIMIZE_QUOTES_STATUS = 'UPDATE_OPTIMIZE_QUOTES_STATUS';
export const updateOptimizeQuotesStatusAction = payload => ({
  type: UPDATE_OPTIMIZE_QUOTES_STATUS,
  payload,
});

export const TOGGLE_MAINTENANCEBANNER = 'TOGGLE_MAINTENANCEBANNER';
export const toggleMaintenanceBannerAction = payload => ({
  type: TOGGLE_MAINTENANCEBANNER,
  payload,
});
